<template lang="pug">
  .slider__wrapper
    .slider__list
      hooper(ref="slider" :settings="hooperSettings" @updated="sliderUpdate" @slide="sliderSlide")
        slide(
          v-for="(product, key) of products"
          :key="key"
          :style="{width: (widthItem - (marginRight*(itemsToShow - 1) / itemsToShow)) + 'px', marginRight: marginRight +'px'}"
        )
          .slider-item
            .slider-item__wrapper
              .slider-item__item
                .slider-item__title(v-html="product.title")
                .slider-item__description(v-html="product.description")
                .slider-item__button
                  .slider-item__button-wrapper
                    a.button(:href="product.link")
                      span.button__wrapper(v-html="product.button")
              .slider-item__item
                .slider-item__img
                  img.slider-item__img-wrapper(:src="product.img")
    .slider__pagination
      .pagination-circle
        .pagination-circle__wrapper
          .pagination-circle__item(
            v-for="(product, key) of products"
            :key="key"
            :class="{'pagination-circle__item-active': currentSlide === key}"
            @click="slideTo(key)"
          )

</template>

<script>
import Vue from 'vue'
import {Hooper, Slide} from 'hooper'

export default {
  name: 'AppSlider',

  components: {
    Hooper,
    Slide
  },

  data () {
    return {
      basePath: Vue.config.devtools ? this.$store.state.basePath : '',
      products: [],
      settings: {},
      currentSlide: 0,
      widthItem: 0,
      marginRight: 0,
      itemsToShow: 0,

      hooperSettings: {
        infiniteScroll: false,
        wheelControl: false,
        trimWhiteSpace: true,
        mouseDrag: true,
        touchDrag: true,
        breakpoints: {
          1240: {
            itemsToShow: 1,
            marginRight: 0
          },
          1024: {
            itemsToShow: 1,
            marginRight: 0
          },
          768: {
            itemsToShow: 1,
            marginRight: 0
          },
          640: {
            itemsToShow: 1,
            marginRight: 0
          },
          514: {
            itemsToShow: 1,
            marginRight: 0
          },
          480: {
            itemsToShow: 1,
            marginRight: 0
          },
          360: {
            itemsToShow: 1,
            marginRight: 0
          },
          320: {
            itemsToShow: 1,
            marginRight: 0
          }
        }
      }
    }
  },

  methods: {
    sliderSlide (payload) {
      this.currentSlide = payload.currentSlide
    },

    slideTo (index) {
      this.$refs.slider.slideTo(index)
    },

    sliderUpdate (payload) {
      this.widthItem = payload.slideWidth
      this.marginRight = payload.settings.marginRight
      this.itemsToShow = payload.settings.itemsToShow
      this.$refs.slider.slideWidth = this.widthItem + (this.marginRight / this.itemsToShow)
    },

    slidePrev () {
      this.$refs.slider.slidePrev()
    },

    slideNext () {
      this.$refs.slider.slideNext()
    }
  },

  created () {
    this.products = window.RbcApp.arSlider.list
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Slider/AppSlider.vue